/* eslint-disable react/react-in-jsx-scope */
import React from 'react';
import './ChartXAxis.scss';

const CustomXAxis = () => {
	return (
		<div className="custom-xaxis-container">
			<div>10 a.m.</div>
			<div>2 p.m.</div>
			<div>4 p.m.</div>
		</div>
	);
};

export default CustomXAxis;
